var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasValidLink)?_c('button',{staticClass:"border text-xs rounded-md px-2 py-1 focus:outline-none shadow",class:_vm.getClassesByType,on:{"click":_vm.openLink}},[_vm._v(" "+_vm._s(_vm.getText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }